// extracted by mini-css-extract-plugin
module.exports = {"description":"_15LpcKpnvHFU9qO-poH_11"};